import React, { useState } from 'react';
import { CalendarClock, Plus, Loader2 } from 'lucide-react';
import { authAxios } from '../../services/crmApi';

interface Props {
  applicationId: number;
  onCreated?: () => void;
}

export function FollowUpWidget({ applicationId, onCreated }: Props) {
  const [open, setOpen] = useState(false);
  const [dueDate, setDueDate] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const handleCreate = async () => {
    if (!dueDate) return;
    setSaving(true);
    try {
      await authAxios.post(`/api/operator/follow-up/${applicationId}`, {
        due_date: dueDate,
        note: note || undefined,
      });
      setOpen(false);
      setDueDate('');
      setNote('');
      onCreated?.();
    } catch { /* ignore */ }
    setSaving(false);
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="w-full flex items-center gap-2 px-3 py-2 text-xs text-gray-600 hover:bg-blue-50 hover:text-blue-700 rounded-lg transition-colors"
      >
        <CalendarClock size={14} />
        <span>Zaplanuj follow-up</span>
      </button>
    );
  }

  return (
    <div className="border rounded-lg p-3 space-y-2 bg-blue-50/50">
      <div className="flex items-center gap-2 text-xs font-medium text-blue-800">
        <CalendarClock size={14} />
        Follow-up
      </div>
      <input
        type="date"
        value={dueDate}
        onChange={e => setDueDate(e.target.value)}
        min={new Date().toISOString().slice(0, 10)}
        className="w-full text-xs border rounded-md px-2 py-1.5 focus:ring-2 focus:ring-blue-400"
      />
      <textarea
        value={note}
        onChange={e => setNote(e.target.value)}
        placeholder="Notatka (opcjonalnie)"
        rows={2}
        className="w-full text-xs border rounded-md px-2 py-1.5 resize-none focus:ring-2 focus:ring-blue-400"
      />
      <div className="flex gap-2">
        <button
          onClick={handleCreate}
          disabled={!dueDate || saving}
          className="flex-1 flex items-center justify-center gap-1.5 text-xs px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {saving ? <Loader2 size={12} className="animate-spin" /> : <Plus size={12} />}
          Utwórz
        </button>
        <button
          onClick={() => { setOpen(false); setDueDate(''); setNote(''); }}
          className="text-xs px-3 py-1.5 border rounded-md hover:bg-gray-50"
        >
          Anuluj
        </button>
      </div>
    </div>
  );
}
